<template>
        <div
            class="col-xl-6 col-12 d-flex flex-wrap justify-content-center justify-content-xl-start align-content-start align-items-start mt-md-4 mt-xl-0">
            
            <div class="col-xxl-8 col-10 text-start titleOption t-18 t-sm-14 t-xl-9 t-xxl-6 mb-1 mb-xl-3 mt-4 mt-xl-0">
                Whatsapp Destinatario
            </div>
            <div
                class="col-xxl-8 col-10 d-flex justify-content-start align-content-start align-items-start ps-xl-4 ps-2">
                <input tabindex="1" ref="receiverWhatsapp" maxlength="10" autocomplete='off' pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}" spellcheck='false' autocorrect='off'
                    class="w-100 inputText t-xxl-4 t-16 t-sm-11 t-xl-8" placeholder="Numero telefónico 10 digitos"
                    v-model="formFields.step2.receiverWhatsapp" :type="(mobile == true) ? 'tel' : 'text'"
                    @paste="pasteFilterNumber($event)" @copy="disableCopy" @keydown="onlyNumbers($event)">
            </div>
            <div class="col-xxl-8 col-10 text-start titleOption t-18 t-sm-14 t-xl-9 t-xxl-6 mb-1 mb-xl-3 mt-4 mt-xl-5">
                Mensaje
            </div>
            <div
                class="col-xxl-8 col-10 d-flex justify-content-start align-content-start align-i    tems-start ps-xl-4 ps-2">
                <textarea tabindex="2" maxlength="250" autocomplete='off' spellcheck='false' autocorrect='off'
                    class="w-100 inputText t-xxl-4 t-16 t-sm-11 t-xl-8" placeholder="Mensaje 250 caracteres" rows="7"
                    v-model="formFields.step2.receiverMessage" @paste="pasteFilterComment($event)" @copy="disableCopy"
                    @keydown="onlyComment($event)"></textarea>
            </div>
            
            <div class="col-xxl-8 col-10 text-start ts-2 mt-5 d-flex justify-content-end">
                <button tabindex="3" class="generalButton t-xl-12 t-xxl-8 t-30 t-sm-24" @click="validateNextness()">Continuar</button>
            </div>
        </div>
</template>

<script>
import designList from '@/components/designList.vue'

export default {
    name: 'step2',
    emits: ['setData', 'progress', 'showModal', 'setLoading'],
    components: {
        designList
    },
    props: {
        lang:{
            default:"es",
            type: String
        },
        con:{
            default:{},
            type: Object
        },
        formFields: {},
        cities:{
            default:[],
            type: Array
        }
    },
    computed: {
        daysInMonth() {
            return this.getDaysInMonth(this.selectedMonth);
        },
    },
   
    mounted() {
        this.mobile = this.isMobile();
    },
    methods: {
        setErr(name){
            this.$refs[name].classList.add('err')
        },
        removeErr(name){
            this.$refs[name].classList.remove('err')
        },
        validateNextness(){
            let receiverWhatsapp = this.validateField('number', this.formFields.step2.receiverWhatsapp, 10, 10);

            if(receiverWhatsapp){
                this.removeErr('receiverWhatsapp')
            }else{
                this.setErr('receiverWhatsapp')
            }
            if(receiverWhatsapp){
                this.step(2)
            }
        },
        setValue(step, field, value) {
            let form = this.formFields[step];
            form[field] = value;
            this.$emit('setData', form, step);
        },
        step(step) {
            this.$emit('progress', step);
        },
    },
    data() {
        return {
            simbol: require('@/assets/images/a27.svg'),
            mobile: false,
        }
    }
}
</script>

<style scoped lang="css">
.titleOption {
    color: var(--primary);
    font-weight: 600;
}

.labelDescription {
    color: var(--secondary);
    font-weight: 600;
}

.subtitleOption {
    color: var(--sexagenary);
}

.inputText {
    border: 2px solid var(--quartenary);
    border-radius: 12px;
    padding: 12px;
    outline: none;
    color: var(--primary);
}

.selectInput {
    border: 2px solid var(--quartenary);
    border-radius: 12px;
    padding: 10px;
    color: var(--primary);
    appearance: none;
}

textarea {
    resize: none;
}

.linkChange {
    color: var(--septagenary);
    cursor: pointer;
    font-weight: 700;
}

.linkChange:hover {
    color: var(--primary);
}
</style>
